import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=15cd3098&"
import script from "./TabGeneral.vue?vue&type=script&lang=ts&"
export * from "./TabGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('15cd3098', component.options)
    } else {
      api.reload('15cd3098', component.options)
    }
    module.hot.accept("./TabGeneral.vue?vue&type=template&id=15cd3098&", function () {
      api.rerender('15cd3098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/tabs/TabGeneral.vue"
export default component.exports